<fieldset class="group">
    <legend>{{ "FLIGHT_LIST.edit.crewMembers" | translate }}</legend>
    @for (row of rows().controls; track row) {
        <div class="fields row crew" [formGroup]="row">
            <label class="field">
                <span class="label">{{ "FLIGHT_LIST.edit.crewMember" | translate }}</span>
                <!-- Empty to type a crew member the organization does not keep yet. -->
                <kendo-combobox
                    formControlName="crewId"
                    [data]="options()[$index]"
                    textField="name"
                    valueField="id"
                    [valuePrimitive]="true"
                    [placeholder]="'FLIGHT_LIST.edit.typeCrewMember' | translate"
                    [kendoDropDownFilter]="{ operator: 'contains' }"
                ></kendo-combobox>
            </label>
            <label class="field">
                <span class="label">{{ "FLIGHT_LIST.crew.firstName" | translate }}</span>
                <kendo-textbox formControlName="firstName"></kendo-textbox>
            </label>
            <label class="field">
                <span class="label">{{ "FLIGHT_LIST.crew.lastName" | translate }}</span>
                <kendo-textbox formControlName="lastName"></kendo-textbox>
            </label>
            <label class="field">
                <span class="label">{{ "FLIGHT_LIST.crew.role" | translate }}</span>
                <kendo-combobox formControlName="crewRoleId" [data]="lookups().crewRoles" textField="name" valueField="id" [valuePrimitive]="true"></kendo-combobox>
            </label>
            <button kendoButton fillMode="flat" class="remove" [svgIcon]="icons.remove" [title]="'FLIGHT_LIST.edit.removeCrewMember' | translate" (click)="remove($index)"></button>
            @if (row.invalid && row.touched) {
                <span class="error row-error">{{ "FLIGHT_LIST.edit.errors.crewMember" | translate }}</span>
            }
        </div>
    } @empty {
        <p class="empty">{{ "FLIGHT_LIST.empty.crew" | translate }}</p>
    }
    @if (rows().hasError("duplicate")) {
        <p class="error">{{ "FLIGHT_LIST.edit.errors.duplicateCrewMember" | translate }}</p>
    }
    <button kendoButton fillMode="flat" class="add" [svgIcon]="icons.add" (click)="add()">{{ "FLIGHT_LIST.edit.addCrewMember" | translate }}</button>
</fieldset>
